import React, { useEffect, useState } from "react";
import { Col, Divider, Progress, Row, Table, Tag } from "antd";
import api from "../../api";
import Loader from "../../components/spin/Loader";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const fetchStats = async () => {
    setLoading(true);
    const res = await api.get_stats();

    if (res.status === 200) {
      setData(res.data.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const STATUS_MAP = {
    ongoing: { label: "Ongoing", color: "success" },
    upcoming: { label: "Upcoming", color: "processing" },
    drawing: { label: "Drawing", color: "warning" },
    completed: { label: "Completed", color: "default" },
  };

  const columns = [
    {
      title: "Код",
      dataIndex: "prefix",
      key: "prefix",
      width: 200,
      render: (v) => <span style={{ fontWeight: 500 }}>{v}</span>,
    },
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      render: (v) => <span style={{ fontWeight: 500 }}>{v}</span>,
    },
    {
      title: "Нийт дугаар",
      dataIndex: "ticket_qty",
      key: "ticket_qty",
      render: (v) => v,
    },
    {
      title: "Зарагдсан",
      dataIndex: "sold",
      key: "sold",
      render: (v) => v ?? 0,
    },
    // {
    //   title: "Дүүрэлт",
    //   key: "pct",
    //   render: (_, r) => {
    //     const pct =
    //       r.ticket_qty > 0 ? Math.floor((r.sold / r.ticket_qty) * 100) : 0;
    //     return (
    //       <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    //         <Progress
    //           percent={pct}
    //           size="small"
    //           showInfo={false}
    //           style={{ flex: 1, margin: 0 }}
    //           strokeColor={pct === 100 ? "#52c41a" : "#378ADD"}
    //         />
    //         <span style={{ fontSize: 11, color: "#888", minWidth: 28 }}>
    //           {pct}%
    //         </span>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      render: (v) => {
        const s = STATUS_MAP[v] ?? { label: v, color: "default" };
        return <Tag color={s.color}>{s.label}</Tag>;
      },
    },
  ];

  if (loading) return <Loader />;
  if (!data) return null;

  const { lotteries, tickets, participants, sms } = data;

  const getLotteryPath = (record) => {
    if (record.visibility === "draft") {
      return `/lottery/draft/${record.id}/edit`;
    }

    if (record.status === "completed") {
      return `/lottery/completed/${record.id}/edit`;
    }

    return `/lottery/active/${record.id}/edit`;
  };

  return (
    <div>
      {/* Ерөнхий үзүүлэлт */}
      {/* <div className="section-wrap"> */}
      {/* <p className="section-label">Ерөнхий үзүүлэлт</p> */}
      <Row gutter={[12, 12]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            label="Нийт сугалаа"
            value={lotteries.total}
            sub={`${lotteries.this_month} энэ сард`}
            badgeType="info"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            label="Идэвхтэй сугалаа"
            value={lotteries.active}
            badgeText="Явагдаж байна"
            badgeType="success"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            label="Энэ сард зарагдсан"
            value={tickets.this_month_sold.toLocaleString()}
            badgeType="success"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard
            label="SMS явуулсан"
            value={sms.total.toLocaleString()}
            sub={`${sms.this_month.toLocaleString()} энэ сард`}
            // badgeText={`${sms.failed} амжилтгүй`}
            // badgeType={sms.failed > 0 ? "warning" : "success"}
          />
        </Col>
        {/* <Col xs={24} sm={12} md={8}>
              <StatCard
                label="Нийт оролцогч"
                value={participants.total.toLocaleString()}
                sub={`${participants.this_month.toLocaleString()} энэ сард`}
              />
            </Col> */}
        {/* <Col xs={24} sm={12} md={8}>
          <StatCard
              label="Нийт дугаар"
              value={tickets.total.toLocaleString()}
              // sub={`${tickets.sold.toLocaleString()} зарагдсан`}
              // progress={tickets.sold_percent}
            />
        </Col> */}
      </Row>
      {/* </div> */}

      {/* Энэ сард үүссэн сугалаа */}

      <div className="section-wrap">
        <div className="section-label">Энэ сард үүссэн сугалаа</div>
        <Table
          columns={columns}
          dataSource={lotteries.this_month_list}
          rowKey="id"
          pagination={false}
          style={{
            marginBottom: 28,
            borderRadius: 8,
          }}
          onRow={(record) => ({
            onClick: () => navigate(getLotteryPath(record)),
            style: { cursor: "pointer" },
          })}
        />
      </div>
    </div>
  );
};

const StatCard = ({ label, value, sub, badgeText, badgeType }) => (
  <div className="stat-card">
    {/* <p className="stat-label">{label}</p> */}
    <Divider
      orientation="left"
      plain
      variant="solid"
      style={{ borderColor: "#0066CC", marginBottom: "5px" }}
    >
      <h4>{label}</h4>
    </Divider>
    <div className="stat-value">{value}</div>
    {sub && <div className="stat-sub">{sub}</div>}
    {badgeText && (
      <span className={`badge badge-${badgeType}`}>{badgeText}</span>
    )}
  </div>
);

export default Dashboard;
